import { IdLabel } from "../../../components/IdLabel/index.js";
import { useEvent } from "../hooks/useEvent.js";
import "react";
import { Fragment as Fragment$1, jsx, jsxs } from "react/jsx-runtime";
//#region src/modules/Events/shared/EventName.tsx
function EventName({ id, name, showId }) {
	const { data } = useEvent({ eventId: id || "" }, {
		cacheStrategy: "cache-only",
		fire: !!id
	});
	if (name) return /* @__PURE__ */ jsx("span", { children: name });
	if (data) return /* @__PURE__ */ jsxs("span", { children: [data.eventType.name, showId && /* @__PURE__ */ jsxs(Fragment$1, { children: [" ", /* @__PURE__ */ jsx(IdLabel, {
		className: "text-color-subtle font-medium",
		idLabel: data.event.idLabel
	})] })] });
	return null;
}
//#endregion
export { EventName };

//# sourceMappingURL=EventName.js.map